import { Component } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { companyInformation } from '../../../../companyinformation';


@Component({
  selector: 'anon-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
  public readonly companyInformation = companyInformation;
  public currentYear: number = new Date().getFullYear();
  public currentApplicationVersion = environment.appVersion;
}
